import { apiRequest } from '@/common/utils/request.common'
import {
  API_BASE_URL_STORE,
  HTTP_METHOD_POST,
} from '@/common/utils/request.const'
import { normalizeConsentRenewEmail } from '@/common/normalize/normalize-consent-renew-email'

export const postConsentRenewEmail = async ({
  token = '',
  isAgree = false,
}) => {
  try {
    const response = await apiRequest({
      url: `${API_BASE_URL_STORE}/v1/consent/renew/email`,
      method: HTTP_METHOD_POST,
      data: {
        consent_token: token,
        agree: isAgree,
      },
    })

    if (!response) return { data: undefined, error: null }
    response.data = normalizeConsentRenewEmail(response?.data)
    response.error = null

    return response
  } catch (error) {
    return {
      data: undefined,
      error: error?.response ?? { message: error?.message, code: error?.code },
    }
  }
}
